<ng-container *ngIf="!appSetting.isMobile">
	<ng-container *ngIf="!notificationReady">
		<i class="nav-link jmRoundCenterBackground" style="color: #7F8C8D; background-color: #ecf0f1; margin-right: 15px;"></i>
	</ng-container>

	<section *ngIf="notificationReady" ngbDropdown [autoClose]="'outside'">
		<i ngbDropdownToggle class="nav-link icnBell jmRoundCenterBackground" role="button" style="color:#7F8C8D; background-color:#ecf0f1; margin-right:15px; display:inline-block;">
			<span *ngIf="notifications.length > 0" style="border-radius:100%; color:#fff; background-color:#FAD59A; padding:5px; font-size:10px; position:absolute; top:0; width: 20px; height:20px; line-height:1;">{{notifications.length}}</span>
		</i>
		<div ngbDropdownMenu style="width:400px; left:-330px;">
			<div class="jmArrowUp"></div>
			<ul class="w-100" style="padding:10px; max-height:300px; overflow-x:hidden; overflow-y:auto;">
				<li ngbDropdownItem *ngIf="notifications.length === 0" style="text-align:center; height:100%; border:none;">No New Notification</li>
				<li ngbDropdownItem *ngFor="let n of notifications" style="background-color:#eee; padding:5px; margin-top:10px; white-space:normal;">
					<table style="width:100%">
						<colgroup><col style="width:25px" /><col /><col style="width:62px" /></colgroup>
						<tr>
							<td style="padding:5px;"><div style="display:inline-block;border-radius:100%; background-color:#78BEEC; width:20px; height:20px;">&nbsp;</div></td>
							<td style="padding:5px;">
								<span [innerHTML]="n.Notification"></span>
								<span *ngIf="n.NotificationId == '6' || n.NotificationId == '7' || n.NotificationId == '8'" [innerHTML]="n.Age" style="margin-left:5px;"></span>
							</td>
							<td style="padding:5px;"><a href="javascript:void(0);" class="text-info" (click)="handleNotification(n)" style="text-transform: uppercase;">{{n.Type}}</a></td>
						</tr>
					</table>
				</li>
			</ul>
		</div>
	</section>
</ng-container>
<ng-container *ngIf="appSetting.isMobile">
	<section ngbDropdown [autoClose]="'outside'" *ngIf="notifications.length > 0" style="display:inline-block; margin-right:15px; position:unset;">
		<i ngbDropdownToggle *ngIf="notificationReady" class="icnBell jmRoundCenterBackground" role="button" style="color: #7F8C8D; background-color: #ecf0f1; position: relative; display: inline-block;">
			<span style="border-radius:100%; color:#fff; background-color:#FAD59A; padding:5px; font-size:10px; position:absolute; top:0px; width: 20px; height:20px; line-height:1;">{{notifications.length}}</span>
		</i>
		<div ngbDropdownMenu style="margin:0px; color:#000; padding:0px;">
			<ul class="w-100" style="padding:10px; max-height:300px; overflow-x:hidden; overflow-y:auto;">
				<li ngbDropdownItem *ngFor="let n of notifications" style="background-color:#eee; padding:5px; margin-top:10px;">
					<table style="width:100%; white-space:normal;">
						<colgroup><col style="width:25px" /><col /><col style="width:62px" /></colgroup>
						<tr>
							<td style="padding:5px;"><div style="display:inline-block;border-radius:100%; background-color:#78BEEC; width:20px; height:20px;">&nbsp;</div></td>
							<td style="padding:5px;">
								<span [innerHTML]="n.Notification"></span>
								<span *ngIf="n.NotificationId == '6' || n.NotificationId == '7' || n.NotificationId == '8'" [innerHTML]="n.Age" style="margin-left:5px;"></span>
							</td>
							<td style="padding:5px;"><a href="javascript:void(0);" class="text-info" (click)="handleNotification(n)" style="text-transform: uppercase;">{{n.Type}}</a></td>
						</tr>
					</table>
				</li>
			</ul>
		</div>
	</section>
</ng-container>
